import request from '@/utils/request'
import { resolveApiBase } from '@/utils/apiBase'

export function getContractPage(params) {
  return request({
    url: '/api/contract/page',
    method: 'get',
    params
  })
}

export function getContractDetail(id) {
  return request({
    url: `/api/contract/${id}`,
    method: 'get'
  })
}

export function getContractFromQuoteContext(quoteId) {
  return request({
    url: '/api/contract/from-quote-context',
    method: 'get',
    params: { quoteId }
  })
}

export function createContractFromQuote(data) {
  return request({
    url: '/api/contract/from-quote',
    method: 'post',
    data
  })
}

export function updateContract(id, data) {
  return request({
    url: `/api/contract/${id}`,
    method: 'put',
    data
  })
}

export function uploadSignedContract(id, file, options = {}) {
  const fd = new FormData()
  fd.append('file', file)
  if (options.autoCreateProject === true) {
    fd.append('autoCreateProject', 'true')
  }
  if (options.projectManagerUserId != null && options.projectManagerUserId !== '') {
    fd.append('projectManagerUserId', String(options.projectManagerUserId))
  }
  if (options.projectName) {
    fd.append('projectName', String(options.projectName))
  }
  return request({
    url: `/api/contract/${id}/upload-signed`,
    method: 'post',
    data: fd,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function downloadSignedUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/download-signed`
}

export function regenerateContractDocument(id) {
  return request({
    url: `/api/contract/${id}/regenerate-document`,
    method: 'post'
  })
}

export function downloadGeneratedUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/download-generated`
}

export function previewGeneratedUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/preview-generated`
}

export function previewSignedUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/preview-signed`
}

/** 预览「最新签字版」合同 PDF（双方签 > 客户已签）。 */
export function previewSignedPackageUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/preview-signed-package`
}

/** 下载「最新签字版」合同 PDF（双方签 > 客户已签）。 */
export function downloadSignedPackageUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/download-signed-package`
}

/** 预览当前可用合同（签字版优先，否则合并初稿）。 */
export function previewContractDocumentUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/preview-document`
}

/** 下载当前可用合同（签字版优先，否则合并初稿）。 */
export function downloadContractDocumentUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/download-document`
}

export function getPublicContractLink(id) {
  return request({
    url: `/api/contract/${id}/public-link`,
    method: 'get'
  })
}

export function listContractSignAudits(id) {
  return request({
    url: `/api/contract/${id}/sign-audits`,
    method: 'get'
  })
}

export function downloadCustomerSignatureUrl(id) {
  const base = resolveApiBase()
  return `${base}/api/contract/${id}/download-customer-signature`
}

export function sendContractToCustomer(id, payload) {
  return request({
    url: `/api/contract/${id}/send-to-customer`,
    method: 'post',
    data: payload || {}
  })
}

export function companySignContract(id, data) {
  return request({
    url: `/api/contract/${id}/company-sign`,
    method: 'post',
    data: data || {}
  })
}

export function sendFinalContractToCustomer(id, payload) {
  return request({
    url: `/api/contract/${id}/send-final-to-customer`,
    method: 'post',
    data: payload || {}
  })
}

export function archiveContractWithFlow(id, file) {
  const fd = new FormData()
  if (file) {
    fd.append('file', file)
  }
  return request({
    url: `/api/contract/${id}/archive-with-flow`,
    method: 'post',
    data: fd,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function listContractPaymentPlans(contractId) {
  return request({
    url: `/api/contract/${contractId}/payment-plans`,
    method: 'get'
  })
}

export function saveContractPaymentPlan(contractId, data) {
  return request({
    url: `/api/contract/${contractId}/payment-plans`,
    method: 'post',
    data
  })
}

export function updateContractPaymentPlan(contractId, planId, data) {
  return request({
    url: `/api/contract/${contractId}/payment-plans/${planId}`,
    method: 'put',
    data
  })
}

export function deleteContractPaymentPlan(contractId, planId) {
  return request({
    url: `/api/contract/${contractId}/payment-plans/${planId}`,
    method: 'delete'
  })
}
